<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
            :page-title="$t('Training Modules')"
            :directory="$t('datatables')"
            :icon="'grid'"
        />
      </div>
    </div>
    <div class="card card-with-search border-0 card-with-shadow">
      <div class="card-body border-bottom d-flex justify-content-between align-items-center flex-wrap">
        <div>
          <h5 class="mb-1">Portal Credits</h5>
          <p class="mb-0 text-muted">Credits are used for screenings and credit-based training assignments.</p>
        </div>
        <a href="/portal-credits" class="btn btn-primary mt-2 mt-md-0">View Credits</a>
      </div>
      <div class="text-justify">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </div>
</template>

<script>
import AppLibrary from "../../../Helpers/AppLibrary";

export default {
  name: "UserTrainings",
  extends: AppLibrary,
  components: {
  },
  data() {
    return {
      tabsHorizontal: [
        {
          icon: "info",
          name: "Available Trainings",
          component: "certificate-certificates",
          permission: "",
          props: {certificateType: 'trainingCertificates'}
        },
        {
          icon: "file-check",
          name: "My Trainings",
          component: "certificate-applied",
          permission: "",
          props: {applicationType: 'user', certificate_type: 'employee_certification'}
        },
        {
          icon: "certificate",
          name: "Certificate Users",
          component: "certificate-users",
          permission: "",
        },
        {
          icon: "certificate",
          name: "Training Request",
          component: "training-request",
          permission: "",
        },
        {
          icon: "certificate",
          name: "My Certificates",
          component: "training-list",
          permission: "",
          props: {type: 'training_certificate'}
        },

      ],
    };
  },
  created() {

  },
  methods: {
    setTabs() {
      this.tabsHorizontal.forEach((element) => {
        if (element.name == 'Certificate Users' || element.name == 'Training Request') {
            element.permission = this.isCompanyAdmin === 1;
        }
      });
    }
  },
  mounted() {
    setTimeout(() => {
      this.setTabs();
    }, 3000);
  },
  computed: {
    isCompanyAdmin() {
      return this.$store.state.user.loggedInUser.is_company_admin;
    },
  },
  watch:{
    isCompanyAdmin(newValue, oldValue){
      this.setTabs()
    }
  }
};
</script>
